
import UIContainer from "../../ui/UIContainer";
import DashboardTopBar from "./DashboardTopBar";
import './Dashboard.scss';
import View from "../View";
import { useEffect } from "react";
import LoadingOverlay from "../../ui/overlay/LoadingOverlay";
import { Navigate, Outlet, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { MainView } from "./main/MainView";
import Flex from "../../data/Flex";
import ConfirmOverlay from "../../ui/overlay/ConfirmOverlay";
import Api from "../../api/Api";
import LoginView from "../LoginView";
import { listen, unlisten } from "../../dispatcher/Dispatcher";
import AppEvent from "../../events/AppEvent";



import UserOverlay from "../../ui/overlay/UserOverlay";
import UserProfileOverlay from "../../ui/overlay/UserProfileOverlay";

export interface IDashboardWrapperViewProps{

}

Dashboard.ID = "dashboard";
Dashboard.PATH = "/";
 
export default function Dashboard($props:IDashboardWrapperViewProps){


    const location = useLocation();
    
    let navigation = useNavigate();

    const _onForceLogout = ()=>{
        _logout();
        ConfirmOverlay.show("forceLogout",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Your session expired or your token has become invalid"});
    }


    useEffect(()=>{
        navigation(MainView.PATH);
        listen(AppEvent.FORCE_LOGOUT, _onForceLogout);
        LoadingOverlay.hide("loginLoading");

        return ()=>{
            unlisten(AppEvent.FORCE_LOGOUT, _onForceLogout);
        }
    },[]);

    useEffect(()=>{
        if(location.pathname===Dashboard.PATH){
            navigation(MainView.PATH);
        }
    },[location.pathname]);

    const _logout=()=>{
        const hideLoading = LoadingOverlay.show("loggingOut",{desc:"Logging Out"});

        Api.access.logout();
        localStorage.clear();
        hideLoading();
        navigation(LoginView.PATH);
    }

    const _tryLogout=()=>{        
        ConfirmOverlay.show("confirmLogout",{
            title:"Confirm Logout",
            message:"Are you sure you want to logout?",
            confirmAction:()=>{
                _logout();
            },
            confirmLabel:"Logout",
            cancelLabel:"Cancel"
        });
    }


    const _userView=()=>{  
        UserOverlay.show("loggingOut",{desc:"Logging Out"});
    }         
    

    const _userProfile=()=>{  
        UserProfileOverlay.show("myProfile",{desc:"My Profile"});
    }         


    return (
        <View whiteBG id={Dashboard.ID}>
            <DashboardTopBar logout={_tryLogout} userView={_userView} userProfile={_userProfile}/>
            <UIContainer flex={{justifyContent:Flex.STRETCH, alignItems:Flex.FLEX_START}}>  
                <Outlet/>
            </UIContainer>
        </View>
    )
}